import React, { useEffect } from "react"
import gsap from 'gsap'
import { graphql } from "gatsby"
import Seo from "../components/seo"
import Spacer from "../components/spacer"
import Layout from "../components/layout"
import Showreel from "../components/showreel"
import IntroText from "../components/introText"
import AnimateCaption from "../components/animateCaption"
import FeaturedProjects from "../components/featuredProjects"

const titleState = { y: '100%' }
const captionState = { opacity: 0 }

const IndexPage = ({ data }) => {

  var home = data.allDatoCmsHomepage.nodes[0];

  useEffect(() => {
    var tl = gsap.timeline({ delay: 1 });
    tl.to('.showreel--animate .background', { height: 0, duration: 1.65, ease: "power4.inOut" });
    tl.fromTo('.title--animate .homepage--logo', titleState, { y: 0, duration: 1.4, ease: "power4.inOut" }, '-=1.35');
    tl.fromTo('.masthead, .small--caption', { opacity: 0 }, { opacity: 1, duration: .75, ease: "power2.inOut" }, '-=.5');
    tl.play();
  }, [])
  return (
    <Layout>
      <Seo titleTemplate={false} title="GROUNDCREW | Brand, Design and Development" />
      <Spacer className='header' />
      <Spacer />
      <Spacer />
      <div className='title--animate'>
        <div className='homepage--logo logo--main' style={titleState} />
      </div>
      <div className='hide'>
        <AnimateCaption style={captionState} text={home.heroCaption} titles={home.captionLoop} />
      </div>
      <Spacer />
      <Spacer />
      <div className="small--caption ma uppercase size-medium text-center text-normal"  >
        Strategy.  Brand.  Digital.
      </div>
      <div className='showreel--animate'>
        <Showreel video={home.showreelLink} />
        <div className='background' />
      </div>
      <Spacer />
      <IntroText text={home.introduction} />
      <Spacer />
      <FeaturedProjects projects={home.featuredProjects} />
      <Spacer />
    </Layout>
  )
}
export default IndexPage

export const query = graphql`
  query Homepage {
    allDatoCmsHomepage {
      nodes {
        showreelLink
        heroCaption
        captionLoop {
          caption
        }
        introduction
        featuredProjects {
          name
          year
          slug
          scope
          comingSoon
          featuredRatio
          projectColor {
            hex
          }
          featuredVideo
          featuredImage {
            gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 1200)
          }
        }
      }
    }
    services:allDatoCmsServiceType(sort: {fields: position, order: ASC}) {
      nodes {
        name
        position
        featuredVideo
        featuredImage {
          gatsbyImageData
        }
      }
    }
    news:allDatoCmsNews(limit: 4) {
      nodes {
        title
        slug
        website
        category {
          name
        }
        meta {
          publishedAt(formatString: "DD MMM Y")
        }
      }
    }
  }
`